module.exports = __webpack_public_path__ + "media/images/cip-e54ec615fdf69440b80924cafff98b3f.png";